import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

export default ['JsonRPCService', (JsonRPCService) => {
    const repairerOnlyPSA = !ApplicationFeatures.hasFeature('role.producer') && ApplicationFeatures.hasFeature('role.vendor'); // PSA
    let appPSA = 'pc';
    if (repairerOnlyPSA) {
        appPSA = 'cc';
    }
    return {
        hasUserPermission: (permission) => {
            return JsonRPCService.send(appPSA, 'gateway/user', 'hasUserPermission', [permission]); // PSA
        },
        hasUserSystemPermission: (permission) => {
            return JsonRPCService.send(appPSA, 'gateway/user', 'hasUserSystemPermission', [permission]); // PSA
        },
        getAvailableProducerCodesForCurrentUser: () => {
            return JsonRPCService.send(appPSA, 'gateway/user', 'getAvailableProducerCodesForCurrentUser', []); // PSA
        },
        hasUserAccessToAccountPolicies: (accountNumber) => {
            return JsonRPCService.send(appPSA, 'gateway/user', 'hasUserAccessToAccountPolicies', [accountNumber]); // PSA
        },
        //UCWPRODENG-875
        hasUserSystemPermissionforClaim: (permission, xCenter) => {
            return JsonRPCService.send(xCenter, 'gateway/user', 'hasUserSystemPermission', [permission]); // PSA
        }
    };
}];
